import React from "react";
// import { ChevronLeft, ArrowRightShort, Check2Square, XSquare } from 'react-bootstrap-icons';
import { Container, Col, Row, Card, Alert } from "react-bootstrap";

import { IconError } from "../../../../assets/icons";

function UnSuccessPayment(props) {
  return (
    <>
      <Container className="my-auto text-center" style={{ maxWidth: "500px" }}>
        <Card
          className="rounded-4  shadow-sm"
          style={{ border: "1px solid #f9e3e8" }}
        >
          <Card.Header
            className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
            style={{ background: "#f9e3e8" }}
          >
            <IconError fillColor="red" />
            <div className="text-danger fw-bold fs-103 mt-2">پرداخت ناموفق</div>
            <div className="text-danger mt-1 fs-08">
              عملیات پرداخت انجام نشد.{" "}
            </div>
          </Card.Header>
          <Card.Body>
            <Row className=" mt-3 mb-4">
              <Col xs="12" className="fs-09">
                پرداخت شما ناموفق بود.
              </Col>
            </Row>
            <Row className="mt-4">
              <Col xs="12" className="fs-09">
                <Alert variant="danger"> {props.errorText}</Alert>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default UnSuccessPayment;
